import TimeZoneUtil from 'lib/TimeZoneUtil';

class CompanySettingMap {
    static mapCompanySettingToUpdate(record) {
        return {
            companyName: record.companyName,
            companyAddress: record.companyAddress,
            companyCity: record.companyCity,
            companyState: record.companyState,
            companyZip: record.companyZip,
            companyCountry: record.companyCountry,
            companyPhone: record.companyPhone,
            companyFax: record.companyFax,
            companyEmail: record.companyEmail,
            companyWebsite: record.companyWebsite,
            companyContact: record.companyContact,
            companyEin: record.companyEin,
            companyTimeZoneId: record.companyTimeZoneId,
            companyTimezone: TimeZoneUtil.getTimeZoneOffSet(record.companyTimeZoneId),
            companyStateRtAccount: record.companyStateRtAccount,
        };
    }
}

export default CompanySettingMap;
